import axios from "axios";

const server = "https://api.senikcompany.com/";
const local = 'http://localhost:5039/';

export const axiosConfig = axios.create({
    baseURL: server,
    headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
});
    